import { reactive } from 'vue';

export const criarObraOs = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        idbairro: 0,
        idobratpservico: 0,
        idequipamento: 0,
        cdobraos: 0,
        dtobraos: '',
        detalhamento: '',
        nmlogradouro: '',
        nmendereco: 0,
        referencia: '',
        latitude: 0,
        longitude: 0,
        dhautorizacao: '',
        lgautorizacao: 0,
        dtinicio: '',
        hrinicio: '',
        dtfim: '',
        hrfim: '',
        status: 0,
        statusnm: '',
        idlogin: 0,
        idusuario: 0
    });
};